import { render } from "./CentralIntake.vue?vue&type=template&id=76865423&ts=true"
import script from "./CentralIntake.ts?vue&type=script&lang=ts&external"
export * from "./CentralIntake.ts?vue&type=script&lang=ts&external"

import "./CentralIntake.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__